<p>single-value-time works!</p>
